import PropTypes from 'prop-types'

import {
  distributeAssetsByCategory,
  joinAssetNames,
} from 'features/creative/creativeUtil'

const CreativeListItemDetail = ({ assetTypes, onClickItem }) => {
  const assetInfo = distributeAssetsByCategory(assetTypes)
  return (
    <>
      <td>
        <div className="inner_tbl" />
      </td>
      <td>
        <div className="inner_tbl" />
      </td>
      <td>
        <div className="inner_tbl" />
      </td>
      <td onClick={onClickItem}>
        <div className="inner_tbl">
          <div className="item_box">
            <span className="txt_type">
              이미지형
              <span className="fc_emph"> {assetInfo.image.length}</span>
            </span>{' '}
            {joinAssetNames(assetInfo.image)}
          </div>
          <div className="item_box">
            <span className="txt_type">
              텍스트형
              <span className="fc_emph"> {assetInfo.text.length}</span>
            </span>{' '}
            {joinAssetNames(assetInfo.text)}
          </div>
          <div className="item_box">
            <span className="txt_type">
              버튼형
              <span className="fc_emph"> {assetInfo.button.length}</span>
            </span>{' '}
            {joinAssetNames(assetInfo.button)}
          </div>
          <div className="item_box">
            <span className="txt_type">
              연동형
              <span className="fc_emph"> {assetInfo.link.length}</span>
            </span>{' '}
            {joinAssetNames(assetInfo.link)}
          </div>
        </div>
      </td>
      <td>
        <div className="inner_tbl" />
      </td>
      <td>
        <div className="inner_tbl" />
      </td>
      <td>
        <div className="inner_tbl" />
      </td>
      <td>
        <div className="inner_tbl" />
      </td>
      <td>
        <div className="inner_tbl" />
      </td>
    </>
  )
}

export default CreativeListItemDetail

CreativeListItemDetail.propTypes = {
  assetTypes: PropTypes.array.isRequired,
  onClickItem: PropTypes.func.isRequired,
}
